import axios from 'axios';
import Cookies from 'universal-cookie';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

function authHeaders(extra = {}) {
    const token = new Cookies().get('token');
    return { headers: { authorization: `Bearer ${token}`, ...extra } };
}

const base = (projectUuid) => `${API_BASE}/project/${projectUuid}/tendency-report`;

// --- Analyses (cards) ---
export function listTrAnalyses(projectUuid) {
    return axios.get(`${base(projectUuid)}/analyses`, authHeaders());
}

export function createTrAnalysis(projectUuid, title = null) {
    return axios.post(`${base(projectUuid)}/analyses`, { title }, authHeaders());
}

export function deleteTrAnalysis(projectUuid, analysisUuid) {
    return axios.delete(`${base(projectUuid)}/analyses/${analysisUuid}`, authHeaders());
}

// --- Sources ---
export function getTrSources(projectUuid, analysisUuid) {
    return axios.get(`${base(projectUuid)}/analyses/${analysisUuid}/sources`, authHeaders());
}

export function saveTrSources(projectUuid, analysisUuid, selection) {
    return axios.post(`${base(projectUuid)}/analyses/${analysisUuid}/sources`, selection, authHeaders());
}

export function uploadTrPdf(projectUuid, analysisUuid, file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${base(projectUuid)}/analyses/${analysisUuid}/sources/pdf`, formData, authHeaders({ 'Content-Type': 'multipart/form-data' }));
}

export function removeTrPdf(projectUuid, analysisUuid, index) {
    return axios.delete(`${base(projectUuid)}/analyses/${analysisUuid}/sources/pdf/${index}`, authHeaders());
}

// --- AI artifacts: type = tr_report | tr_insights ---
export function generateTrArtifact(projectUuid, analysisUuid, type) {
    return axios.post(`${base(projectUuid)}/analyses/${analysisUuid}/${type}/generate`, {}, authHeaders());
}

export function getTrArtifact(projectUuid, analysisUuid, type) {
    return axios.get(`${base(projectUuid)}/analyses/${analysisUuid}/${type}`, authHeaders());
}
